export const table = {
	defaultCategoryName: "Produits",
	exportExcel: "Exporter Excel",
	productCount: {
		singular: "produit",
		plural: "produits",
	},
	loading: {
		categories: "Chargement des catégories",
		products: "Chargement des Produits",
	},
	dropdown: {
		editCategory: "Éditer la catégorie",
		deleteCategory: "Supprimer la catégorie",
		categoryButton: "Catégorie",
	},
	columns: {
		bars: "Bars",
		barsTooltip: "Cliquez pour voir les bars",
		barsLabel: "Bars",
		mountableTooltip: "Cliquez pour voir le produit montable",
		productionRuleTooltip: "Cliquez pour voir la règle de production",
		active: "Status",
		mountableDescription: "Montable",
		fiscalCode: "SKU",
		name: "Produit",
		hasProductionRule: "Fiche technique",
		fiscalData: "Données fiscales",
		value: "Prix",
		actions: "Actions",
	},
	fiscalStatus: {
		testedTooltip: "Données fiscales enregistrées et validées",
		errorTooltip: "Nous avons trouvé des erreurs dans les données fiscales présentées",
		notTestedTooltip: "Données fiscales enregistrées. En attente de test.",
	},
	variablePrice: "Variable",
	validation: {
		pricePositive: "Le prix doit être une valeur positive",
		maxValue: "Le prix ne doit pas dépasser la valeur maximale autorisée (21 474 836,47)",
	},
	priceUpdateSuccess: "Le prix de {{productName}} a été mis à jour avec succès.",
	priceChangeModal: {
		title: "Modifier le prix du produit",
		description:
			"Vous modifiez le prix du produit <strong>{{productName}}</strong> pour <strong>{{price}}</strong>.",
		secondParagraph:
			"Avant de quitter l'édition du prix, confirmez si vous souhaitez continuer avec la modification ou annuler.",
		cancelButton: "Annuler",
		confirmButton: "Modifier le prix",
	},
	priceChangeInvalidModal: {
		title: "Valeur invalide",
		description:
			"La valeur saisie n'est pas valide. L'ancien prix du produit sera conservé.",
		cancelButton: "Annuler",
	},
	priceUpdateCancelledNotification: {
		title: "Impossible de mettre à jour le prix",
		description: "Nous avons conservé le dernier prix du produit",
	},
	priceUpdateSuccessNotification: {
		title: "Prix mis à jour avec succès !",
		description: "{{productName}} a été mis à jour à {{price}}",
	},
	notifications: {
		copyImageSuccess: {
			title: "Succès !",
			description: "Hash de l'image copié dans le presse-papier",
		},
	},
	emptyState: {
		categoryWithoutProducts: "Catégorie sans produits",
		noProductsFound: "Aucun produit trouvé",
		addProducts: "Ajoutez des produits et liez-les à cette catégorie.",
		noSearchResults:
			"Nous n'avons pas trouvé de produits qui correspondent à votre recherche de",
		clearSearchButton: "Effacer la recherche",
		clearFiltersButton: "Effacer les filtres",
		andToAppliedFilters: "et aux filtres appliqués",
		inCategory: 'dans la catégorie "{{categoryName}}"',
		noProductsMatchingFilters:
			"Nous n'avons pas trouvé de produits qui correspondent aux filtres appliqués",
	},
};
